<div class="row container-form-list mb-4">
    <div class="col-12">
        <div class="card">
            <div class="card-header">
                <h6 class="card-title">Representantes</h6>
                <small class="card-subtitle">Informe os representantes desta região</small>
            </div>

            <div class="table-responsive">
                <table class="table table-striped table-hover table-bordered">
                    <thead>
                        <tr>
                            <th class="col-delete"></th>
                            <th class="col-representante">Representante</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let entity of entities; let i = index">
                            <td class="col-delete">
                                <a class="btn btn-link" (click)="delete(i)">
                                    <i class="far fa-trash-alt" aria-hidden="true"></i>
                                </a>
                            </td>
                            <td class="col-representante">
                                <sgt-typeahead-representante [(ngModel)]="entity.representante" name="representante_{{i}}" id="representante_{{i}}"
                                    #representante="ngModel" [ngControl]="representante" #typeaheadRepresentante [situacao]="1" required="required" [dropup]="true"
                                    (typeaheadChange)="onChangeRepresentante(entity, $event)">
                                </sgt-typeahead-representante>
                                <sgt-form-control-error
                                    *ngIf="representante.errors && representante.errors.required && representante.dirty"
                                    msgError="O representante é obrigatório">
                                </sgt-form-control-error>
                            </td>
                        </tr>
                        <tr *ngIf="entities.length === 0" class="no-record">
                            <td class="text-center" colspan="2">
                                <i class='fas fa-info' aria-hidden='true'></i> Nenhum registro encontrado
                            </td>
                        </tr>
                    </tbody>
                    <tfoot class="table-footer">
                        <tr>
                            <td colspan="2">
                                <button type="button" class="btn btn-primary btn-sm mr-2" (click)="insert()">
                                    <i class="fas fa-plus" aria-hidden="true"></i> Adicionar Representante
                                </button>
                                <button type="button" class="btn btn-light btn-sm" (click)="openPopulaCidadeModal()">
                                    <i class="fas fa-bolt" aria-hidden="true"></i> Adicionar Vários Representantes
                                </button>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</div>

<!-- Modal para popular os representantes -->
<sgt-regiao-representante-popula-modal
    #regiaoRepresentantePopulaModal
    [entities]="entities">
</sgt-regiao-representante-popula-modal>
